export const PlusIcon = ({ className }) => (
   <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
   <g id="icons / bx-plus">
   <path id="Vector" d="M12.6673 7.3335H8.66732V3.3335H7.33398V7.3335H3.33398V8.66683H7.33398V12.6668H8.66732V8.66683H12.6673V7.3335Z" fill="currentColor"/>
   </g>
   </svg>
)